export const thaiMonths = [
  "มกราคม", // January (i18n-ignore: Thai month data, translate at render with t())
  "กุมภาพันธ์", // February (i18n-ignore: Thai month data, translate at render with t())
  "มีนาคม", // March (i18n-ignore: Thai month data, translate at render with t())
  "เมษายน", // April (i18n-ignore: Thai month data, translate at render with t())
  "พฤษภาคม", // May (i18n-ignore: Thai month data, translate at render with t())
  "มิถุนายน", // June (i18n-ignore: Thai month data, translate at render with t())
  "กรกฎาคม", // July (i18n-ignore: Thai month data, translate at render with t())
  "สิงหาคม", // August (i18n-ignore: Thai month data, translate at render with t())
  "กันยายน", // September (i18n-ignore: Thai month data, translate at render with t())
  "ตุลาคม", // October (i18n-ignore: Thai month data, translate at render with t())
  "พฤศจิกายน", // November (i18n-ignore: Thai month data, translate at render with t())
  "ธันวาคม", // December (i18n-ignore: Thai month data, translate at render with t())
];
